import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

export default function HandsOnToFree({
  children,
  title,
  subTitleone,
  subTitleTwo,
  leftSection,
  rightSection,
  id,
  buttonLink = "/signup",
}) {
  const navigate = useNavigate();
  // Safely access UserContext - it might not be available on public routes
  const userContext = useContext(UserContext);
  const userData = userContext?.userData || null;

  const handleGetStartedClick = () => {
    if (userData) {
      // User is logged in, redirect to dashboard
      navigate("/dashboard");
    } else {
      // User is not logged in, redirect to signup
      navigate(buttonLink);
    }
  };

  return (
    <>
      <div
        id={id}
        className="lg:max-w-[1440px] w-full mx-auto sm2:block hidden"
      >
        {" "}
        <div className="md:px-12 px-5 md:py-[64px] py-8 w-full mx-auto">
          {" "}
          <div className="flex flex-col gap-3 md:gap-4  lg:gap-6  ">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] border border-[#3CAB5C]  px-3 py-1 rounded-full  font-medium w-fit">
              What Makes Properteasy Different
            </h5>

            {children}

            <h1 className=" font-medium w-full  text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
              {title}
            </h1>
            {/* Comparison Section Start */}
            <div className="md:py-16 py-6 grid md:grid-cols-2 gap-x-6 gap-y-0">
              {[0, 1, 2, 3].map((idx) => (
                <React.Fragment key={idx}>
                  {/* Left item */}
                  <div
                    className={`bg-[#F7F7F7] p-6 py-2  flex flex-col justify-between h-full ${
                      idx === 0
                        ? "rounded-t-[24px]"
                        : idx === 3
                        ? "rounded-b-[24px] pb-8"
                        : ""
                    }`}
                  >
                    {idx === 0 && (
                      <h2 className="md:text-[48px] h-full  md:min-h-[250px] pt-4 leading-tight lg:min-h-[200px] min-h-[100px] text-[24px] text-[#242424] font-medium text-center">
                        {subTitleone}
                      </h2>
                    )}
                    <div className="group flex p-6 gap-3 items-center   font-[500] rounded-[20px] bg-white text-[#242424] hover:bg-[#3CAB5C] hover:text-white hover:font-semibold transition-all duration-300 h-full">
                      <div className="flex justify-center items-center min-w-[36px]">
                        <img
                          className="w-[36px] h-[36px] transition-all duration-300 [filter:invert(100%)_sepia(0%)_saturate(0%)_hue-rotate(170deg)_brightness(9%)_contrast(101%)] group-hover:[filter:invert(100%)_sepia(100%)_saturate(0%)_hue-rotate(170deg)_brightness(109%)_contrast(101%)]"
                          src={leftSection[idx]?.icon}
                          alt=""
                        />
                      </div>
                      <h2 className="text-[18px] md:text-[22px] font-[500]">
                        {leftSection[idx]?.text}
                      </h2>
                    </div>
                  </div>

                  {/* Right item */}
                  <div
                    className={`bg-[#3CAB5C] p-6 py-2 flex flex-col justify-between h-full ${
                      idx === 0
                        ? "rounded-t-[24px]"
                        : idx === 3
                        ? "rounded-b-[24px] pb-8"
                        : ""
                    }`}
                  >
                    {idx === 0 && (
                      <h2 className="md:text-[48px] h-full  md:min-h-[250px] pt-4 leading-tight lg:min-h-[200px] min-h-[100px] text-[24px] text-[#FFFFFF] font-medium text-center">
                        {subTitleTwo}
                      </h2>
                    )}
                    <div className="group flex p-6 gap-3 items-center rounded-[20px] bg-[#52C171] text-[#FFFFFF] hover:bg-[#FFFFFF] hover:text-[#3CAB5C] hover:font-semibold transition-all duration-300 h-full">
                      <div className="flex justify-center items-center min-w-[36px]">
                        <img
                          className="w-[36px] h-[36px] transition-all duration-300 [filter:invert(100%)_sepia(100%)_saturate(0%)_hue-rotate(170deg)_brightness(109%)_contrast(101%)] group-hover:[filter:invert(50%)_sepia(69%)_saturate(396%)_hue-rotate(85deg)_brightness(98%)_contrast(91%)]"
                          src={rightSection[idx]?.icon}
                          alt=""
                        />
                      </div>
                      <h2 className="text-[18px] md:text-[22px] font-[500]">
                        {rightSection[idx]?.text}
                      </h2>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>

            <button
              className="bg-[#3cab5c] border border-transparent  hover:border-[#3c8f47] focus:border-[#3c8f47] focus:outline-none  m-auto w-fit hover:bg-[#3c8f47] text-white px-6 py-4 rounded-xl font-medium"
              onClick={handleGetStartedClick}
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
      <div className="lg:max-w-[1440px] w-full mx-auto block sm2:hidden">
        {" "}
        <div className="md:px-12 px-5 md:py-[64px] py-8 w-full mx-auto">
          {" "}
          <div className="flex flex-col gap-3 md:gap-4  lg:gap-6  ">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] border border-[#3CAB5C]  px-3 py-1 rounded-full  font-medium w-fit">
              What Makes Properteasy Different
            </h5>
            {children}

            <h1 className=" font-medium w-full  text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
              {title}
            </h1>
            {/* Comparison Section Start */}
            <div className="md:py-16 py-6 flex items-stretch flex-col md:flex-row gap-6">
              <div className="bg-[#F7F7F7] rounded-[24px] md:py-11 py-8 px-6 flex flex-col flex-1 ">
                <h2 className="md:text-[48px] md:h-[250px] lg:h-[200px]  h-[100px] text-[24px]  text-[#242424] font-medium text-center ">
                  {subTitleone}
                </h2>
                <div className="md:pb-[100px]  pb-8  flex flex-col gap-3  rounded-[20px]  bg-[#F6F7F9]">
                  {" "}
                  {leftSection.map((item, idx) => (
                    <div
                      key={idx}
                      className="group flex p-6 gap-3 font-[500] rounded-[20px] bg-white text-[#242424] hover:bg-[#3CAB5C] hover:text-white hover:font-semibold transition-all duration-300"
                    >
                      <div className="flex justify-center items-center min-w-[36px]">
                        <img
                          className="w-[36px] h-[36px]  transition-all duration-300 [filter:invert(100%)_sepia(0%)_saturate(0%)_hue-rotate(170deg)_brightness(9%)_contrast(101%)] group-hover:[filter:invert(100%)_sepia(100%)_saturate(0%)_hue-rotate(170deg)_brightness(109%)_contrast(101%)]"
                          src={item.icon}
                          alt=""
                        />
                      </div>
                      <h2 className="text-[18px] md:text-[22px] font-[500]">
                        {item.text}
                      </h2>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-[#3CAB5C] rounded-[24px] md:py-11 py-8 px-6 flex flex-col  flex-1">
                <h2 className="md:text-[48px] md:h-[250px]  lg:h-[200px] h-[100px] text-[24px]  text-[#FFFFFF] font-medium text-center ">
                  {subTitleTwo}
                </h2>
                <div className="md:pb-[100px]  pb-8 flex flex-col gap-3  rounded-[20px]  ">
                  {" "}
                  {rightSection.map((item, idx) => (
                    <div
                      key={idx}
                      className="group flex p-6 gap-3 rounded-[20px] bg-[#52C171] text-[#FFFFFF] hover:bg-[#FFFFFF] hover:text-[#3CAB5C] hover:font-semibold transition-all duration-300"
                    >
                      <div className="flex justify-center items-center min-w-[36px]">
                        <img
                          className="w-[36px] h-[36px]  transition-all duration-300 [filter:invert(100%)_sepia(100%)_saturate(0%)_hue-rotate(170deg)_brightness(109%)_contrast(101%)] group-hover:[filter:invert(50%)_sepia(69%)_saturate(396%)_hue-rotate(85deg)_brightness(98%)_contrast(91%)]"
                          src={item.icon}
                          alt=""
                        />
                      </div>
                      <h2 className="text-[18px] md:text-[22px] font-[500]">
                        {item.text}
                      </h2>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <button
              className="bg-[#3cab5c]  m-auto w-fit hover:bg-[#3c8f47] text-white px-6 py-3 rounded-xl font-medium"
              onClick={handleGetStartedClick}
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
